import { createFeatureSelector, createSelector } from '@ngrx/store';
import { paymentDataFeatureKey } from '../reducers';
import { PaymentDataState } from '../reducers/payment.reducer';

export const selectPaymentDataSate = createFeatureSelector<PaymentDataState>(
  paymentDataFeatureKey
);

export const selectPaymentData = createSelector(
  selectPaymentDataSate,
  (state) => state.paymentData
);
